import { render, staticRenderFns } from "./KirvanoUpsellVideoVSL.vue?vue&type=template&id=0626601c&lang=br"
import script from "./KirvanoUpsellVideoVSL.vue?vue&type=script&lang=js"
export * from "./KirvanoUpsellVideoVSL.vue?vue&type=script&lang=js"
import style0 from "./KirvanoUpsellVideoVSL.vue?vue&type=style&index=0&id=0626601c&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports